import styled from "styled-components";
import { getHexOpacity } from "../../../../../utils/pipes";
const bgFlorence = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/background-florence.svg`;

export const ModalUserAiNavigator = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  height: 100%;
  width: 100%;
  .modal-background {
    background-color: ${`#090949${getHexOpacity(0.5)}`};
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 100;
  }
  .modal-container {
    overflow: hidden;
    max-height: 90%;
    z-index: 200;
    background-color: #ffffff;
    width: 90%;
    margin: auto;
    box-sizing: border-box;
    border-radius: 14px;
    justify-content: end;
    display: flex;
    flex-direction: column;
    position: relative;
    max-width: 1200px;
    &__reaction {
      width: 100%;
      margin: 200px 0;
    }
    .content {
      display: flex;
      width: 100%;
      box-sizing: border-box;
      position: relative;
      height: calc(100% - 57px);
      &__left {
        padding: 40px 20px;
        box-sizing: border-box;
        justify-items: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      &__right {
        background-color: #e9e9f5;
        box-sizing: border-box;
        display: flex;
        width: 100%;
      }
      .patient-ai-navigator-info {
        flex-direction: column;
        padding: 38.5px 20px;
        display: flex;
      }
      .patient-image {
        width: 189px;
        height: 242px;
        position: relative;
        &__border {
          width: 179px;
          height: 233px;
          border: 5px solid #ffffff80;
          position: absolute;
          border-radius: 176px;
        }
        &__img {
          display: flex;
          width: 100%;
          height: 100%;
          border-radius: 176px;
          object-fit: cover;
        }
        &__img-shadow {
          position: absolute;
          width: 110%;
          height: 105%;
          border-radius: 176px;
          top: -5px;
          opacity: 0.3;
          filter: blur(30px);
          left: -22px;
          z-index: -1;
        }
      }
      .patient-principal-info {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 25px;
        .patient-name {
          text-align: center;
          line-height: 25px;
          font-family: "Nunito Sans Light";
          background: linear-gradient(
            97.31deg,
            #fc7aac -6.15%,
            #d16cc2 9.57%,
            #ac61d4 26.6%,
            #8d58e4 42.32%,
            #7651f0 59.36%,
            #654bf8 77.7%,
            #5c48fd 98.66%,
            #5948ff 124.86%
          );
          color: transparent;
          background-clip: text;
        }
        .patient-info {
          display: flex;
          color: #3e3e5b;
          align-items: center;
          &__separator {
            margin: 0 10px;
            height: 7px;
            border-right: 1px solid #cfd3dd;
          }
          &__id-number {
            font-size: 20px;
          }
        }
      }
      .patient-general-note {
        margin-top: auto;
      }
      .patient-card {
        margin-bottom: 20px;
        border-radius: 20px;
        background: #fff;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex: 1;
        &__left {
          width: 40%;
        }
        &__right {
          width: 60%;
          border-left: 1px solid #cfd3dd;
        }
        .title-space {
          display: flex;
          align-items: center;
          color: #707582;
          font-family: Nunito Sans;
          font-size: 20px;
          width: 100%;
          justify-content: space-between;
          &__icon {
            font-size: 14px;
          }
        }
        .management-link {
          cursor: pointer;
          font-size: 14px;
          color: #3e3da3;
          text-decoration: underline;
        }
        .lists-separator {
          border-bottom: 1px solid #cfd3dd;
          margin: 0 20px;
          box-sizing: border-box;
        }
        .patient-contact {
          padding: 20px;
          .contact-item {
            margin: 10px 0;
            &__title {
              font-family: Nunito Sans;
              font-size: 14px;
              color: #707582;
            }
            &__value {
              font-family: Nunito Sans;
              font-size: 17px;
              color: #1f1f52;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            &__birthdate-alert {
              font-size: 17px;
              margin-top: 5px;
              display: flex;
              align-items: center;
              &-text {
                background: linear-gradient(
                  97.31deg,
                  #fc7aac -6.15%,
                  #d16cc2 9.57%,
                  #ac61d4 26.6%,
                  #8d58e4 42.32%,
                  #7651f0 59.36%,
                  #654bf8 77.7%,
                  #5c48fd 98.66%,
                  #5948ff 124.86%
                );
                color: transparent;
                background-clip: text;
              }
              &-icon {
                margin-left: 5px;
              }
            }
          }
        }
        .patient-programs {
          padding: 15px 20px 15px 20px;
          &__list {
            width: 100%;
            .header-list {
              display: flex;
              align-items: center;
              justify-content: space-between;
              color: #3e3e5b;
              font-family: Nunito Sans Bold;
              font-size: 14px;
              margin-top: 20px;
              width: 100%;
            }
            .list {
              overflow: auto;
              display: flex;
              flex-direction: column;
              margin-top: 10px;
              width: 100%;
              .program-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                color: #1f1f52;
                font-family: Nunito Sans;
                font-size: 14px;
                /* height: calc(100% - 20px); */
                width: 100%;
                margin-bottom: 5px;
              }
            }
          }
        }
        .manage-status {
          background-color: #e9e9f5;
          border: 2px solid #ffffff;
          border-left: none;
          border-bottom-right-radius: 20px;
          padding: 10px 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .user-ainavigator-boxes {
        height: calc(100% - 330px);
        position: relative;
        overflow: auto;
        flex: 1;
      }
    }
    .footer {
      display: flex;
      padding: 10px 20px;
      background: #e9e9f5;
      justify-content: space-between;
      border-top: 1px solid #ffffff;
      &__right {
        display: flex;
      }
      .button-container {
        margin-left: 10px;
      }
    }
  }
`;

export const PopUpPatientOptions = styled.div`
  background-color: #eeeef7;
  border: 2px solid #ffffff;
  width: 393px;
  /* height: 493px; */
  max-height: 600px;
  border-radius: 20px;
  box-shadow: 0px 3px 10px 3px #1c1f5833;

  .header {
    border-bottom: 2px solid #ffffff;
    padding: 10px 20px;
    font-family: Nunito Sans Bold;
    color: #1f1f52;
    font-size: 20px;
  }
  .options-list {
    padding: 20px 10px;
  }
  .option {
    display: flex;
    padding: 18px 10px;
    border-radius: 20px;
    justify-content: space-between;
    background-color: #ffffff;
    align-items: center;
    cursor: pointer;
    &__text {
      font-family: Nunito Sans;
      font-size: 18px;
      color: #3e3e5b;
    }
    &__icon {
      font-size: 13px;
      color: #0c0aa2;
    }
  }
`;
